export default __webpack_public_path__ + "static/waves-9479c305fafd67aa17ef5b681a0ecb2d.png";